export function getChatMessagePayload(data) {
  return data?.message ?? data
}

export function isIncomingCustomerMessage(data) {
  const message = getChatMessagePayload(data)
  if (!message) return false

  const source = message.source?.toLowerCase()
  if (source !== 'customer') return false

  const status = message.status?.toLowerCase()
  if (status && status !== 'published') return false

  return true
}

export function getIncomingCustomerId(data) {
  const message = getChatMessagePayload(data)
  const id = message?.customerId
  return id != null ? id.toString() : null
}

export function getIncomingStoreId(data) {
  const message = getChatMessagePayload(data)
  const id = message?.storeId
  return id != null && id !== '' ? String(id) : null
}

export function isChatMessageForCustomer(data, customerId) {
  const incomingId = getIncomingCustomerId(data)
  if (!incomingId || customerId == null) return false
  return incomingId === customerId.toString()
}
